/** Consulta múltiple de productos (saldo, IVA, etc.) vía Flexy. baseURL ya incluye /api. */
export const FLEXY_PRODUCTS_MULTIPLE_PATH = '/flexy/products/multiple'

/** Catálogo completo con saldos Flexy (lista de productos). baseURL ya incluye /api. */
export const FLEXY_PRODUCTS_ALL_PATH = '/flexy/all'
